import { resolveLambdaApiUrls } from '@/lib/lambdaProxyUrl';

/** Same-origin path (Vite dev proxy + Amplify Hosting rewrite → product-listing Lambda). */
export const PRODUCT_LISTING_API_PATH = '/api/product-listing';

export async function resolveProductListingUrls(): Promise<{
  proxyPath: string;
  directUrl: string;
} | null> {
  return resolveLambdaApiUrls({
    apiPath: PRODUCT_LISTING_API_PATH,
    customKey: 'productListingUrl',
    viteEnvKey: 'VITE_PRODUCT_LISTING_URL',
  });
}

/** @deprecated Use resolveProductListingUrls — kept for callers that only need the proxy path. */
export async function resolveProductListingUrl(): Promise<string | null> {
  const urls = await resolveProductListingUrls();
  return urls?.proxyPath ?? null;
}
